import { ImportResultsRecord, StaticColumnMap } from '@components/bid_request/details/types';

/**
 * Updates the row data with the static columns
 * @param rowData {ImportResultsRecord[]} - The row data to update
 * @param staticColumnMap {StaticColumnMap} - The static column map
 * @returns {ImportResultsRecord[]} - The updated row data
 */
export const updateRowDataWithStaticColumns = (
  rowData: ImportResultsRecord[],
  staticColumnMap: StaticColumnMap
): ImportResultsRecord[] => {
  return rowData.map(row => {
    const newRow = { ...row };

    // In case there are no custom unmapped columns
    if (!newRow['$unmapped']) newRow['$unmapped'] = {};

    if (Object.keys(staticColumnMap).length > 0) {
      // staticColumnMap is keyed by template_column_key; copy each mapped value into
      // $unmapped at the column's index so it survives as a descriptive custom column.
      Object.keys(staticColumnMap).forEach(key => {
        const columnIndex = staticColumnMap[key][0];
        const columnKey = staticColumnMap[key][1];

        if (row[columnKey] !== undefined) {
          newRow['$unmapped']![columnIndex] = row[columnKey] as string;
        }
      });
    }

    return newRow;
  });
};
